// Import console utility first to enable development mode logging
import "./utils/console";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { Toaster } from "react-hot-toast";
import App from "./App.tsx";
import { apolloClient } from "./lib/apollo.ts";
import { LocaleProvider } from "./i18n/LocaleProvider.tsx";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
    <ApolloProvider client={apolloClient}>
        <BrowserRouter>
            <LocaleProvider>
                <App />
                <Toaster position="top-right" />
            </LocaleProvider>
        </BrowserRouter>
    </ApolloProvider>
);
